const initSocialSharing = () => {
    const location = encodeURI(window.location.href);
    const facebookButtons = document.getElementsByClassName('facebook-share-button');
    const facebookMessengerButtons = document.getElementsByClassName('facebook-messenger-share-button');
    const twitterButtons = document.getElementsByClassName('twitter-share-button');
    const googlePlusButtons = document.getElementsByClassName('google-plus-share-button');
    const facebookLink = `https://www.facebook.com/sharer/sharer.php?kid_directed_site=0&sdk=joey&u=${location}&display=popup&ref=plugin&src=share_button`;
    const facebookMessengerLink = `fb-messenger://share/?link=${location}`;
    const twitterLink = `https://twitter.com/intent/tweet?text=${encodeURIComponent('Have a look at this page on Peak Retreats -')}&url=${location}`;
    const googlePlusLink = `https://plus.google.com/share?url=${location}`;

    if (facebookButtons.length > 0) {
        Array.from(facebookButtons).forEach(facebookButton => {
            facebookButton.addEventListener('click', (e) => {
                let _facebookLink = facebookLink;
                e.preventDefault();
                if(e.target.getAttribute('data-linkOverride')) {
                    _facebookLink = `https://www.facebook.com/sharer/sharer.php?kid_directed_site=0&sdk=joey&u=${e.target.getAttribute('data-linkOverride')}&display=popup&ref=plugin&src=share_button`;
                }
                window.open(_facebookLink, '_blank', 'height=300,width=250');
            });
        });
    }

    if (facebookMessengerButtons.length > 0) {
        Array.from(facebookMessengerButtons).forEach(facebookButton => {
            facebookButton.addEventListener('click', (e) => {
                let _facebookMessengerLink = facebookMessengerLink;
                e.preventDefault();
                if(e.target.getAttribute('data-linkOverride')) {
                    _facebookMessengerLink = `fb-messenger://share/?link=${e.target.getAttribute('data-linkOverride')}`;
                }
                console.log('clicked fb messenger');
                window.open(_facebookMessengerLink, '_blank', 'height=300,width=250');
            });
        });
    }

    if (twitterButtons.length > 0) {
        Array.from(twitterButtons).forEach(twitterButton => {
            twitterButton.addEventListener('click', (e) => {
                let _twitterLink = twitterLink;
                e.preventDefault();
                if(e.target.getAttribute('data-linkOverride')) {
                    _twitterLink = `https://twitter.com/intent/tweet?text=${encodeURIComponent('Have a look at my shortlist on Peak Retreats -')}&url=${e.target.getAttribute('data-linkOverride')}`;
                }
                window.open(_twitterLink, '_blank', 'height=550,width=450');
            });
        });
    }

    if (googlePlusButtons.length > 0) {
        Array.from(googlePlusButtons).forEach(googlePlusButton => {
            googlePlusButton.addEventListener('click', (e) => {
                e.preventDefault();
                window.open(googlePlusLink, '_blank', 'height=550,width=450');
            });
        });
    }
};
export default initSocialSharing;
